import Cookies from 'js-cookie'
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    addPaddingTop: 0,
    searchParams: {}
  },

  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_PADDING_TOP: (state, addPaddingTop) => {
      state.addPaddingTop = addPaddingTop
    },
    SEARCH_PARAMS: (state, searchParams) => {
      state.searchParams = searchParams
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setPaddingTop({ commit }, addPaddingTop) {
      commit('SET_PADDING_TOP', addPaddingTop)
    },
    SEARCH_PARAMS({ commit }, searchParams) {
      commit('SEARCH_PARAMS', searchParams)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js